import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { List, ListItem, Checkbox, FormControlLabel } from '@mui/material';
import { Dialog, TextField, Button } from '@totalsoft/rocket-ui';
import { validationEngine, isMandatory } from 'utils/simple-validations';
import { BoxActionsWrapper } from 'components/common/CommonStyles';

const commentUpdater = (value, cfg) => {
  const validationInfo = validationEngine.validate({ comment: value }, getValidationRules(cfg));
  return {
    comment: value,
    validationInfo
  };
};

const getValidationRules = cfg => {
  if (cfg && cfg.commentRequired) {
    return {
      comment: [isMandatory()]
    };
  }
};

const TaskReasonsComponent = ({ onSaveReasons, currentConfig, task, onCloseReasonsDialog, showCommentsDialog, reasonChange }) => {
  const { t } = useTranslation();
  const [state, setState] = useState({
    comment: '',
    validationInfo: null
  });

  const onCommentChange = useCallback(
    value => {
      setState(commentUpdater(value, currentConfig));
    },
    [currentConfig]
  );

  const onSaveInternal = useCallback(() => {
    const validationInfo = validationEngine.validate({ comment: state.comment }, getValidationRules(currentConfig));
    if (!validationInfo.isValid) {
      setState({ ...state, validationInfo });
      return;
    }

    onSaveReasons(
      task,
      state.comment,
      currentConfig.reasons.filter(x => x.selected).map(a => a.id)
    );
  }, [currentConfig, onSaveReasons, state, task]);

  return (
    <React.Fragment>
      <Dialog
        open={showCommentsDialog}
        onClose={onCloseReasonsDialog}
        aria-labelledby='comment-dialog-title'
        maxWidth={'xs'}
        title={t('TaskReasons.CommentsTitle')}
        content={
          <>
            <TextField
              required={currentConfig.commentRequired}
              fullWidth
              value={state.comment}
              onChange={onCommentChange}
              label={t('TaskReasons.Comment')}
              multiline={true}
              error={state.validationInfo && state.validationInfo.comment ? true : false}
              helperText={state.validationInfo && state.validationInfo.comment}
              inputProps={{
                maxLength: 255
              }}
            />
            <List>
              {currentConfig.reasons.map(r => (
                <ListItem key={r.id} disableGutters={true}>
                  <FormControlLabel control={<Checkbox checked={r.selected} onChange={reasonChange(r.id)} />} label={r.description} />
                </ListItem>
              ))}
            </List>
          </>
        }
        actions={
          <BoxActionsWrapper forDialog>
            <Button onClick={onSaveInternal} disabled={!(state.validationInfo && state.validationInfo.isValid)}>
              {t('Save')}
            </Button>
            <Button onClick={onCloseReasonsDialog}>{t('Close')}</Button>
          </BoxActionsWrapper>
        }
      />
    </React.Fragment>
  );
};

TaskReasonsComponent.propTypes = {
  currentConfig: PropTypes.object.isRequired,
  onCloseReasonsDialog: PropTypes.func.isRequired,
  onSaveReasons: PropTypes.func.isRequired,
  showCommentsDialog: PropTypes.bool.isRequired,
  reasonChange: PropTypes.func.isRequired,
  task: PropTypes.object.isRequired
};

export default TaskReasonsComponent;
